<ng-template #cpuInput>
  <mat-card>
    @if (formData.label?.length > 0) {
      <mat-card-title>{{ formData.label }} {{ formData.isRequired ? '*' : '' }}</mat-card-title>
    }
    <mat-card-content>
      <mat-selection-list
        [attr.aria-label]="formData.label"
        [formControl]="formGroup.controls[formName]"
        [required]="formData.isRequired">
        @for (item of items; track $index) {
          @if (item.value != '-') {
            <mat-list-option
              [class]="item.invalid?'invalid':''"
              [selected]="item.checked"
              [value]="item.value"
              checkboxPosition="before">{{ item.label }}
            </mat-list-option>
          } @if (item.value == '-') {
            <mat-option disabled>
              @if (item.label != null) {
                {{ item.label }}
              }
              <mat-divider [inset]="false"></mat-divider>
            </mat-option>
          }
        }
      </mat-selection-list>
    </mat-card-content>
    <app-error [formGroup]="formGroup" [formName]="formName"></app-error>
  </mat-card>
</ng-template>

<app-base [childContext]="ctx" [componentsTemplate]="cpuInput"></app-base>
